module.exports = __webpack_public_path__ + "static/media/black_check_icon.dcd2af3c.svg";